import React from "react";
import { formatAmount } from "../utils/format";
import { useTranslation } from "react-i18next";

const ProductListItem = ({ product }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white shadow-[0px_6px_26px_rgba(98,107,125,0.07)] h-[84px] pl-[32px] rounded-lg mb-3">
      <div className="grid grid-cols-8 gap-4 items-center h-full mb-4 last:mb-0">
        <div className="col-span-3 flex flex-col justify-center">
          <p className="text-[#043F88] text-[12px] font-semibold">
            {product.reference || "N/A"}
          </p>
          <p className="text-secondary text-[16px] font-semibold">
            {product.name || "Produit Inconnu"}
          </p>
        </div>

        <div className="col-span-1 flex flex-col justify-center items-center">
          <p className="text-[#707070] text-[12px] font-semibold">
            {t(`rows.quantity`).toUpperCase()}
          </p>
          <p className="text-[#043F88] text-[16px] font-semibold">
            {product.quantity || 0}
          </p>
        </div>

        <div className="col-span-1 flex flex-col justify-center items-center">
          <p className="text-[#707070] text-[12px] font-semibold">
            {t(`rows.discount`).toUpperCase()}
          </p>
          <p className="text-[#043F88] text-[16px] font-semibold">
            {product.discount || 0}%
          </p>
        </div>

        <div className="col-span-1 flex flex-col justify-center items-center">
          <p className="text-[#707070] text-[12px] font-semibold">
            {t(`rows.priceuHT`).toUpperCase()}
          </p>
          <p className="text-[#043F88] text-[16px] font-semibold">
            {formatAmount(product.unitPriceHT)}
          </p>
        </div>

        <div className="col-span-1 flex flex-col justify-center items-center">
          <p className="text-[#707070] text-[12px] font-semibold">
            {t(`rows.priceuTTC`).toUpperCase()}
          </p>
          <p className="text-[#043F88] text-[16px] font-semibold">
            {formatAmount(product.unitPriceTTC)}
          </p>
        </div>

        <div className="col-span-1 flex flex-col justify-center items-center">
          <p className="text-[#707070] text-[12px] font-semibold">
            {t(`rows.totalPrice`).toUpperCase()}
          </p>
          <p className="text-[#043F88] text-[16px] font-semibold">
            {formatAmount(product.priceHT)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductListItem;
